<!-- menu-bar.component.html -->

<header class="menu-bar">
  <div class="menu-bar-logo"><a href="/">doctogenic</a></div>

  <nav class="menu-bar-navigation">
    <!-- your links -->
  </nav>

  <div class="menu-bar-time" aria-live="polite">
    {{ time$ | async }}
  </div>

  <div class="menu-bar-profile"></div>

  <div class="menu-bar-messages">
    A study reference for medical students. Biochemistry is available at no cost; additional Step 1 subjects will be added over time.
  </div>

  <div class="menu-bar-alerts"></div>

  <div class="menu-bar-feedback">
    <form class="feedback-form anim-fade" [class.expanded]="isFeedbackFocused" (submit)="submitFeedback($event)"
      (focusin)="onFeedbackFocusIn()" (focusout)="onFeedbackFocusOut($event)" novalidate>
      <label class="sr-only" for="feedbackBox">Feedback</label>

      <textarea #feedbackBox id="feedbackBox" name="feedbackText" [value]="isFeedbackFocused ? feedbackText : ''"
        (input)="onFeedbackInput($event)"
        [attr.placeholder]="isFeedbackFocused ? 'Comments, questions, mistakes?' : 'Comments, questions, mistakes?'"
        class="feedback-input" rows="1" [attr.maxlength]="MAX_FEEDBACK_LEN" autocomplete="off" autocorrect="off"
        autocapitalize="off" spellcheck="false"></textarea>

      <!-- bottom toolbar -->
      <div class="feedback-toolbar">
        <label class="sr-only" for="feedbackEmail">Email (optional)</label>
        <input id="feedbackEmail" name="feedbackEmail" type="email" class="feedback-email"
          placeholder="Email (optional)" title="Email (optional)" autocomplete="email" inputmode="email" [value]="email"
          (input)="onEmailInput($event)" maxlength="320" />

        <span class="char-counter">{{ feedbackText.length }}/{{ MAX_FEEDBACK_LEN }}</span>

        <button type="submit" class="send-btn" [disabled]="!feedbackText.trim() || sending" aria-label="Send"
          title="Send">
          ➤
        </button>
      </div>

      <!-- status pills -->
      <span class="status-pill sending" *ngIf="sending">Sending…</span>
      <span class="status-pill sent" *ngIf="!sending && justSent">Sent</span>
      <span class="status-pill error" *ngIf="!sending && errorMsg">{{ errorMsg }}</span>
    </form>
  </div>
</header>
